import { useGetBankMutationReports } from 'api-hooks/report';
import { NavigationRoutes } from 'common/constants';
import useDefaultValuesReportDate from 'hooks/use-default-values-report-date';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { NavigationProps } from 'types';

import PivotReportTemplate from './components/pivot-report-template';

export type BankMutationReportParams = {
  filter: {
    bank_account: string;
  };
};

export default function BankMutationReport(
  props: NavigationProps<NavigationRoutes.BankMutationReport>,
) {
  const { t } = useTranslation();
  const { query } = useRouter();
  const defaultFilters = useDefaultValuesReportDate('transaction');

  return (
    <PivotReportTemplate
      title={t('common:bank_mutation_report')}
      usePivotQuery={useGetBankMutationReports}
      defaultFilters={[
        {
          name: 'bank_account',
          value: query['filter[bank_account]'] as string,
        },
        ...defaultFilters,
      ]}
      isShowAllFilterCompleted
    />
  );
}
